import React, { useCallback, useEffect, useState } from "react";
import LayoutPage from "../Layout";
import { Helmet } from "react-helmet";
import { Link, useNavigate } from "react-router-dom";
import axios from "axios";
import Swal from "sweetalert2";
import { toast } from "react-toastify";
import DataTable from "react-data-table-component";
import AddCircleIcon from "@mui/icons-material/AddCircle";

function ResearchArt() {
  const [list, setList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [update, setUpdate] = useState(false);
  const [row, setRow] = useState();
  const [pageSize, setPageSize] = useState(10);
  const [pageNumber, setPageNumber] = useState(1);
  const [totalRows, setTotalRows] = useState(0);
  const navigate = useNavigate();

  const getNewsList = useCallback(async () => {
    try {
      setLoading(true);
      const response = await axios.get(
        `/website/getAll-research-articles?pageNumber=${pageNumber}&pageSize=${pageSize}`
      );
      // console.log("sportsNews",response);
      setList(response.data.data.articleList);
      setRow(response.data?.data.length);
      setTotalRows(response.data?.data?.total);
      setLoading(false);
    } catch (error) {
      console.log("Error", error);
    }
  }, [update, pageNumber, pageSize]);

  const columns = [
    // {
    //   name: "News Image",
    //   selector: (row) => row.newsImage,
    //   cell: (item) => {
    //     return (
    //       <img
    //         className="img"
    //         height={35}
    //         width={50}
    //         src={item.newsImage}
    //         alt={item.newsImage}
    //       />
    //     );
    //   },
    // },
    {
      name: "No.",
      selector: (row, index) => index + 1 + (pageNumber - 1) * pageSize,
      width: "100px",
    },
    {
      name: "Topic",
      width: "200px",
      selector: (row) => row.topic,
    },
    {
      name: "Heading",
      width: "220px",
      selector: (row) => row.heading,
    },
    {
      name: "Description",
      width: "400px",
      selector: (row) => row.description,
      // cell: (row) => (
      //   <div title={row.description} className="desciption-cell">
      //     {row.message}
      //   </div>
      // ),
    },
    {
      name: "Edit",
      width: "100px",
      selector: (row) => (
        <i
          className="EditButton fa fa-edit fonts"
          onClick={handleEditButton}
          style={{ color: "#2011a8", cursor: "pointer", marginLeft: "10px" }}
          id={row._id}
        ></i>
      ),
    },
    {
      name: "Action",
      selector: (row) => (
        <i
          onClick={handleDelete}
          id={row._id}
          className=" fa fa-trash"
          style={{
            cursor: "pointer",
            color: "red",
            textAlign: "center",
            marginLeft: "25px",
          }}
        ></i>
      ),
    },
  ];

  const handlePerRowsChange = (number) => {
    setPageSize(number);
  };

  const handlePageChange = (number) => {
    setPageNumber(number);
  };

  const handleEditButton = (e) => {
    // console.log(e._id);
    navigate(`/research-articles/${e.target.id}`);
  };

  const handleDelete = (e) => {
    Swal.fire({
      title: "Are you sure?",
      text: "You will not be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, delete it!",
    }).then((res) => {
      if (res.isConfirmed) {
        setLoading(true);
        axios
          .delete(`/admin-website/delete-researchArticle/${e.target.id}`)
          .then((res) => {
            toast.success("Article deleted successfully!");
            setLoading(false);
            // setTimeout(() => {
            setUpdate((prev) => !prev);
            // }, 1000);
          })
          .catch((err) => {
            toast.error("Failed to delete research article.");
            setLoading(false);
          });
      }
    });
  };

  const customStyle = {
    header: {
      style: {
        // fontSize: "1.2rem",
        border: "1px solid gray",
      },
    },
    headRow: {
      style: {
        fontSize: "1rem",
        border: "1px solid gray",
        backgroundColor: "#8180a6",
      },
    },
    rows: {
      style: {
        fontSize: "1rem",
        // fontWeight:
        border: "1px solid gray",
      },
    },
    pagination: {
      style: {
        fontSize: "1.2rem",
        border: "1px solid gray",
        backgroundColor: "#8180a6",
      },
    },
  };

  useEffect(() => {
    getNewsList();
  }, [getNewsList, update]);
  return (
    <>
      <Helmet>
        <title>Research Articles</title>
      </Helmet>
      <LayoutPage>
        <div className="row">
          <div className="col-12">
            <div className="card my-4">
              <div className="card-header p-0 position-relative mt-n4 mx-3 z-index-2">
                <div
                  style={{
                    backgroundColor: "#46456e",
                    // border: "2px solid green",
                    display: "flex",
                    justifyContent: "space-between",
                  }}
                  className=" shadow-primary border-radius-lg pt-0 pb-3 px-3"
                >
                  <div
                    className="d-flex pt-3"
                    // style={{ border: "2px solid red" }}
                  >
                    <i
                      style={{ color: "#fff", cursor: "pointer" }}
                      className="fa fa-arrow-left fs-4"
                      onClick={() => {
                        navigate("/dashboard");
                      }}
                    ></i>
                    <h6 className="text-white text-capitalize ps-4 ">
                      Research Articles
                    </h6>
                  </div>
                  <div
                    className="add-news-container pt-3"
                    // style={{ border: "2px solid black" }}
                  >
                    <Link
                      to="/research-articles/addArticle"
                      title="Add New"
                      className=" fs-6 px-2 p-2"
                      style={{
                        backgroundColor: "orange",
                        color: "#fff",
                        borderRadius: "5px",
                        fontWeight: "600",
                      }}
                    >
                      <AddCircleIcon className="pe fs-4" /> Add Article
                    </Link>
                  </div>
                </div>
              </div>
              <div className="card-body px-0 pb-2">
                <div className="p-4">
                  <div className="input-group input-group-dynamic">
                    &nbsp; &nbsp;
                  </div>
                  {/* <h1>Sports Categories</h1> */}
                  <div className="table-responsive p-0">
                    <DataTable
                      columns={columns}
                      data={list}
                      // onRowClicked={handleClickedrow}
                      progressPending={loading}
                      paginationServer
                      paginationTotalRows={totalRows}
                      onChangeRowsPerPage={handlePerRowsChange}
                      onChangePage={handlePageChange}
                      sortServer
                      pagination
                      // onSort={handleSort}
                      customStyles={customStyle}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </LayoutPage>
    </>
  );
}

export default ResearchArt;
